import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { memo, useState } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Heading from 'shopper/components/Heading';

import Anchor from 'components/Anchor';

import {
  toCategoryLink,
  toLandingPageLink,
  toStoreOffersLink,
  toSubcategoryLink,
} from 'lib/links';

import BlackFridayGlossaryLetterItem from './BlackFridayGlossaryLetterItem';

import LANDINGS from 'constants/landings';

const GLOSSARY_PAGES = {
  A: [
    {
      name: 'Air Fryer',
      slug: 'air-fryer',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Amazon',
      slug: 'amazon',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Americanas',
      slug: 'americanas',
      type: 'STORE',
    },
    {
      name: 'Ar Condicionado',
      slug: 'ar-condicionado',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Aspirador de Pó',
      slug: 'aspirador-de-po',
      type: 'SUBCATEGORY',
    },
  ],
  B: [
    {
      name: 'Bicicleta',
      slug: 'bicicleta',
      type: 'BLACK_FRIDAY',
    },
  ],
  C: [
    {
      name: 'Cadeira de Escritório',
      slug: 'cadeira-de-escritorio',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Cadeira Gamer',
      slug: 'cadeira-gamer',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Cafeteira',
      slug: 'cafeteiras',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Caixa de Som',
      slug: 'caixa-de-som',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Cama',
      slug: 'cama',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Casas Bahia',
      slug: 'casas-bahia',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Celular',
      slug: 'celular',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Centauro',
      slug: 'centauro',
      type: 'STORE',
    },
    {
      name: 'Cervejeira',
      slug: 'cervejeira',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Colchão',
      slug: 'colchao',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Cooktop',
      slug: 'cooktop',
      type: 'SUBCATEGORY',
    },
  ],
  D: [
    {
      name: 'Dell',
      slug: 'dell',
      type: 'BLACK_FRIDAY',
    },
  ],
  E: [
    {
      name: 'Eletrodomésticos',
      slug: 'eletrodomesticos',
      type: 'CATEGORY',
    },
    {
      name: 'Extra',
      slug: 'extra',
      type: 'BLACK_FRIDAY',
    },
  ],
  F: [
    {
      name: 'Fogão',
      slug: 'fogao',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Fone de Ouvido',
      slug: 'fone-de-ouvido',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Forno Elétrico',
      slug: 'forno-eletrico',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Fralda',
      slug: 'fralda',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Fritadeira',
      slug: 'fritadeira-eletrica',
      type: 'SUBCATEGORY',
    },
  ],
  G: [
    {
      name: 'Galaxy',
      slug: 'galaxy',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Games',
      slug: 'game',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Geladeira',
      slug: 'geladeira',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Guarda Roupa',
      slug: 'guarda-roupa',
      type: 'BLACK_FRIDAY',
    },
  ],
  H: [
    {
      name: 'Headset',
      slug: 'headset',
      type: 'BLACK_FRIDAY',
    },
  ],
  I: [
    {
      name: 'Impressora',
      slug: 'impressora',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'iPhone',
      slug: 'iphone',
      type: 'BLACK_FRIDAY',
    },
  ],
  J: [
    {
      name: 'JBL',
      slug: 'jbl',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Jogo de Panelas',
      slug: 'jogo-de-panelas',
      type: 'BLACK_FRIDAY',
    },
  ],
  K: [
    {
      name: 'Kabum',
      slug: 'kabum',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Kindle',
      slug: 'kindle',
      type: 'BLACK_FRIDAY',
    },
  ],
  L: [
    {
      name: 'Lava Louças',
      slug: 'lava-loucas',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Liquidificador',
      slug: 'liquidificador',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Livro',
      slug: 'livro',
      type: 'BLACK_FRIDAY',
    },
  ],
  M: [
    {
      name: 'Magazine Luiza',
      slug: 'magazine-luiza',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Maquiagem',
      slug: 'maquiagem',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Máquina de Lavar',
      slug: 'maquina-de-lavar',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Marabraz',
      slug: 'marabraz',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Micro-ondas',
      slug: 'micro-ondas',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Monitor',
      slug: 'monitor',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Motorola',
      slug: 'motorola',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Móveis',
      slug: 'moveis',
      type: 'BLACK_FRIDAY',
    },
  ],
  N: [
    {
      name: 'Nespresso',
      slug: 'nespresso',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Netshoes',
      slug: 'netshoes',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Nintendo Switch',
      slug: 'nintendo-switch',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Notebook',
      slug: 'notebook',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Notebook Gamer',
      slug: 'notebook-gamer',
      type: 'BLACK_FRIDAY',
    },
  ],
  P: [
    {
      name: 'PC Gamer',
      slug: 'pc-gamer',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Perfume',
      slug: 'perfume',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Pichau',
      slug: 'pichau',
      type: 'STORE',
    },
    {
      name: 'Placa de Vídeo',
      slug: 'placa-de-video',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Pneu',
      slug: 'pneu',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Pontofrio',
      slug: 'pontofrio',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Processador',
      slug: 'processador',
      type: 'SUBCATEGORY',
    },
    {
      name: 'PS4',
      slug: 'ps4',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'PS5',
      slug: 'ps5',
      type: 'BLACK_FRIDAY',
    },
  ],
  R: [
    {
      name: 'Roupas',
      slug: 'roupas',
      type: 'BLACK_FRIDAY',
    },
  ],
  S: [
    {
      name: 'Samsung',
      slug: 'samsung',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Shoptime',
      slug: 'shoptime',
      type: 'STORE',
    },
    {
      name: 'Smart TV',
      slug: 'tv',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Smartphone',
      slug: 'smartphones-tablets-e-telefones',
      type: 'CATEGORY',
    },
    {
      name: 'Smartwatch',
      slug: 'smartwatch',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Soundbar',
      slug: 'soundbar',
      type: 'SUBCATEGORY',
    },
    {
      name: 'SSD',
      slug: 'hd-ssd',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Submarino',
      slug: 'submarino',
      type: 'BLACK_FRIDAY',
    },
  ],
  T: [
    {
      name: 'Tablet',
      slug: 'tablet',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Teclado e Mouse',
      slug: 'teclado-mouse',
      type: 'SUBCATEGORY',
    },
    {
      name: 'Tênis',
      slug: 'tenis',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'TV',
      slug: 'tv',
      type: 'BLACK_FRIDAY',
    },
  ],
  V: [
    {
      name: 'Ventilador',
      slug: 'ventilador',
      type: 'BLACK_FRIDAY',
    },
  ],
  X: [
    {
      name: 'Xbox',
      slug: 'xbox',
      type: 'BLACK_FRIDAY',
    },
    {
      name: 'Xiaomi',
      slug: 'xiaomi',
      type: 'BLACK_FRIDAY',
    },
  ],
  Z: [
    {
      name: 'Zenfone',
      slug: 'zenfone',
      type: 'BLACK_FRIDAY',
    },
  ],
};

const GLOSSARY_PAGE_TYPES = {
  CATEGORY: 'CATEGORY',
  BLACK_FRIDAY: 'BLACK_FRIDAY',
  SUBCATEGORY: 'SUBCATEGORY',
  STORE: 'STORE',
};

const DEFAULT_SELECTED_LETTER = 'A';
const ALPHABET_LETTERS = [...Array(26)].map((_, i) =>
  String.fromCharCode(i + 65)
);

const getPageLink = (type, slug) => {
  switch (type) {
    case GLOSSARY_PAGE_TYPES.BLACK_FRIDAY:
      return toLandingPageLink(slug, LANDINGS.TYPES.BLACK_FRIDAY);
    case GLOSSARY_PAGE_TYPES.CATEGORY:
      return toCategoryLink(slug);
    case GLOSSARY_PAGE_TYPES.SUBCATEGORY:
      return toSubcategoryLink(slug);
    case GLOSSARY_PAGE_TYPES.STORE:
      return toStoreOffersLink(slug);
    default:
      return '';
  }
};

const BlackFridayGlossary = ({ className }) => {
  const [selectedLetter, setSelectedLetter] = useState(DEFAULT_SELECTED_LETTER);

  return (
    <Box className={twMerge('px-6 pb-12 pt-6 lg:px-10 lg:pb-6', className)}>
      <Heading as="h2" className="mb-4 lg:mb-8" size="size3">
        Glossário Black Friday - Termos iniciados com a letra{' '}
        <Heading
          as="span"
          className="text-primary-500 dark:text-primary-400"
          size="size3"
        >
          {selectedLetter}
        </Heading>
      </Heading>
      <div className="flex flex-row flex-wrap justify-center lg:justify-start">
        {ALPHABET_LETTERS.map((letter) => (
          <BlackFridayGlossaryLetterItem
            key={letter}
            disabled={!GLOSSARY_PAGES[letter]}
            isSelected={selectedLetter === letter}
            onClick={() => {
              setSelectedLetter(letter);
            }}
          >
            {letter}
          </BlackFridayGlossaryLetterItem>
        ))}
      </div>
      {ALPHABET_LETTERS.map((letter) => {
        const pages = GLOSSARY_PAGES[letter];

        if (!pages) {
          return null;
        }

        return (
          <div
            key={`${letter}-links`}
            className={twJoin(
              'mt-8 w-fit flex-col flex-wrap gap-y-6 px-6 lg:mt-12 lg:h-[216px] lg:gap-x-12 lg:px-16',
              letter === selectedLetter ? 'flex' : 'hidden'
            )}
          >
            {pages.map(({ name, type, slug }) => (
              <NextLink
                key={name}
                href={getPageLink(type, slug)}
                prefetch={false}
                passHref
              >
                <Anchor className="font-bold text-neutral-low-200 dark:text-neutral-high-200">
                  {name}
                </Anchor>
              </NextLink>
            ))}
          </div>
        );
      })}
    </Box>
  );
};

BlackFridayGlossary.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default memo(BlackFridayGlossary);
